import $ from 'jquery';
import Swal from 'sweetalert2';
import {
    getConfig,
    getCookieValue,
    getSessionStorage,
    setSessionStorage,
    deleteSessionStorage,
    setCookieValue,
} from './config';
import { buildPageUrl } from './routing';

export const loadScript = (url, callback) => {
    $.ajax({
        url,
        dataType: 'script',
        success: callback,
        async: true,
    });
};

export const debug = (...args) => {
    if (getConfig().debugMode) {
        console.log(`Debug on ${new Date()}\n--- `, ...args);
    }
    if (getConfig().enableAutoLog) {
        debugSave(...args);
    }
};

export const debugSave = (...args) => {
    if (getSessionStorage('envDB')) {
        var dbFile = getSessionStorage('envDB');
    } else {
        var dbFile = [];
    }

    try {
        if (args[0] && !args[1]) {
            dbFile.push(...args);
        }
        if (args[0] && args[1]) {
            dbFile.push(args[0] + " " + args[1]);
        }
    } catch (e) {
        debug("Debugger error:", e);
    }
    setSessionStorage('envDB', dbFile);
};


export const resetDebugCounter = () => {
    setCookieValue("debugCounter", 0, { expires: -1 });
}

export const reportInSlack = (reportLine, notify = true) => {
    const url = String(getConfig().errorDebugURL || '').trim();
    if (!url) {
        return;
    }
    const callSettings = {
        url,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
            content: reportLine,
            notify: notify
        }),
    };
    $.ajax(callSettings)
        .done((data) => {
            if (data.success) {

            }
        }).fail((jqXHR, textStatus, error) => {

        });
}

/*

export const incrementDebugCounter = () => {
if(getConfig().enableAutoLog) {
	var debugCounter = parseInt(getCookieValue("debugCounter"));
	if(!debugCounter){
		debugCounter = 0;
	}
	debugCounter += 1;
	setCookieValue("debugCounter", debugCounter, {expires: 1});
	if(debugCounter >= getConfig().checkoutErrorsCountToSendError){ // make an actual error submit to a gateway

		var realString = "Session ID: *" + getSessionStorage('session_id') + "*\n\n";
		$.each(getSessionStorage('envDB'), function(key, value){

			if(value.indexOf('IP address') != -1) return;
			if(value.indexOf('pathname') != -1) return;
			if(value.indexOf('field set') != -1) return;
			if(value.indexOf('[object Object]') != -1) return;

			realString += value.toString() + "\n";
		});

		const url = getConfig().errorDebugURL;
		const callSettings = {
			url,
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				content: realString
			}),
		};

		$.ajax(callSettings)
			.done((data) => {
				debug(data);
				if(data.success){
					resetDebugCounter();
					deleteSessionStorage('envDB');
				}
			}).fail((jqXHR, textStatus, error) => {
				console.log(`Debugger Error: `, textStatus, error);
			});
	}
}
}

*/

export const saveDebugInfo = () => {

}

export function lowerCaseAllWordsExceptFirstLetters(string) {
    return string.replace(/\S*/g, (word) => word.charAt(0) + word.slice(1).toLowerCase());
}

// Stores IP in session storage for tracking purposes.
export function getIP() {
    const cookieIP = getCookieValue('ip');
    return cookieIP || '127.0.0.1';
}

export function clearPhone(sourcePhone) {
    return sourcePhone.replace(/\D/g, '');
}

export function setIP() {
    const url = String(getConfig().getIPURL || '').trim();
    if (!url) {
        return;
    }
    $.getJSON(
        url,
        (json) => {
            debug('Public IP address: ', json.ip);
            setSessionStorage('ip', json.ip);
            document.cookie = `ip=${json.ip};path=/`;
        },
    );
}

// Builds a percent-encoded query string from a flat params object.
// CheckoutChamp/Konnektive endpoints receive parameters in the query string
// (GET or POST), so every value must be URL-encoded. null/undefined become ''.
export function buildQuery(params) {
    const search = new URLSearchParams();
    Object.keys(params).forEach((key) => {
        const value = params[key];
        search.append(key, value === undefined || value === null ? '' : value);
    });
    return search.toString();
}

export function resetFormState() {
    $('.overlay, .processing').hide();
    $('#orderButtonOff').hide();
    $('#orderButton').show();
    $('#shipping_form, #payment_form').removeClass('knk-submitting');
}

export function throwError(type, message, url = '', rawResponse = '') {
    resetFormState();

    // Konnektive returns most errors as a plain string, but basic field
    // validation errors come back as an object keyed by field, e.g.
    // {firstName: "Not a valid name"}. Flatten those into readable HTML so we
    // never render "[object Object]".
    if (message && typeof message === 'object') {
        const messages = Object.values(message).filter(Boolean);
        message = messages.length ? messages.join('<br>') : 'An unexpected error occurred. Please try again.';
    }

    let is_modal = false;
    let allowOutsideClick = true;
    if (type === 'modal') {
        type = 'error';
        is_modal = true;
        allowOutsideClick = false;
    }
    Swal.fire({
        icon: type,
        html: message,
        allowOutsideClick,
        showCloseButton: false,
    }).then((result) => {
        console.log('error => ', result);
        if (result.isConfirmed || result.dismiss === 'backdrop' || result.dismiss === 'esc' || result.dismiss === 'close') {
            if (url !== '') {
                $(location).prop('href', url);
            }
        } // outside clicked
    });
}

export function handleFinishedOrderError() {
    throwError('error', 'This purchase is already complete or main order not found.', '../');
}

export function saveOrderNumberIntoList(orderId) {
    const storageData = getSessionStorage('ordersList');
    let ordersList = [];
    if (storageData.length > 0) {
        ordersList = JSON.parse(storageData);
    }
    ordersList.push(orderId);
    setSessionStorage('ordersList', JSON.stringify(ordersList));
}

export function skipUpsell() {
    const {
        upsellIndex,
    } = getConfig();
    const ext = getConfig().pageExtension;
    if (getConfig().upsellIndex < getConfig().upsells.length - 1) {
        $(location).prop('href', buildPageUrl(`bonus${getConfig().upsellIndex + 2}`, ext));
    } else {
        $(location).prop('href', buildPageUrl('thankyou', ext));
    }
}

export const getQueryParamValue = (param) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(param);
};

// Capture click-tracking IDs from the landing URL into cookies (was cookies.js).
export function captureClickIds() {
    const urlParams = new URLSearchParams(window.location.search);
    setCookieValue('msclkid', urlParams.get('msclkid'));
    setCookieValue('clickid', urlParams.get('clickid'));
    setCookieValue('cid', urlParams.get('cid'));
}

export function setCustomerState(stateValue) {
    $("[name='cShipState']").find('option').each((index, element) => {
        if (element.value == stateValue) {
            element.selected = 'selected';
        }
    });
}

export function setCustomerShipState(stateValue) {
    $("[name='cShipState']").find('option').each((index, element) => {
        if (element.value == stateValue) {
            element.selected = 'selected';
        }
    });
}

export function setCustomerBillState(stateValue) {
    $("[name='cBillState']").find('option').each((index, element) => {
        if (element.value == stateValue) {
            element.selected = 'selected';
        }
    });
}

export function setCustomerCountry(stateValue) {
    $("[name='cBillCountry']").find('option').each((index, element) => {
        if (element.value == stateValue) element.selected = 'selected';
    });
}

export function getCountryEnv(shippingFieldName) {
    const countrySelector = $(`*[name=${shippingFieldName}]`);
    let country;
    if (countrySelector.length) {
        if (countrySelector.prop('tagName').toLowerCase() == 'input') country = countrySelector.val();
        if (countrySelector.prop('tagName').toLowerCase() == 'select') country = countrySelector.val();
    } else {
        country = 'US';
    }
    return country;
}

export function removeKey(arrayName, key) {
    var x;
    var tmpArray = new Array();
    for (x in arrayName) {
        if (x != key) { tmpArray[x] = arrayName[x]; }
    }
    return tmpArray;
}

var passwordGenerator = {
    _pattern: /[a-zA-Z0-9_\-\+\.]/,
    _getRandomByte: function() {
        if (window.crypto && window.crypto.getRandomValues) {
            var result = new Uint8Array(1);
            window.crypto.getRandomValues(result);
            return result[0];
        } else if (window.msCrypto && window.msCrypto.getRandomValues) {
            var result = new Uint8Array(1);
            window.msCrypto.getRandomValues(result);
            return result[0];
        } else {
            return Math.floor(Math.random() * 256);
        }
    },
    generate: function(length) {
        return Array.apply(null, { 'length': length })
            .map(function() {
                var result;
                while (true) {
                    result = String.fromCharCode(this._getRandomByte());
                    if (this._pattern.test(result)) {
                        return result;
                    }
                }
            }, this)
            .join('');
    }
};

export function debounce(func, timeout = 600) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export function suggestUserEmail(suggestEmailAddress) {
    if (getConfig().suggestEmail) {
        $('<div class="suggestion" id="knkSuggestion">Did you mean <strong id="fullSuggestedEmail">' + suggestEmailAddress + '</strong>?</div>').insertAfter('#cEmail');
        if ($('#knkSuggestion').parent().attr("class").indexOf('col') != -1 || $('#knkSuggestion').parent().attr("class").indexOf('form-group') != -1) {
            $('#knkSuggestion').parent().css("position", "relative");
            $('#knkSuggestion').css("left", $("#cEmail").position().left);
        }
        $('#knkSuggestion').click(function() {
            $('#knkSuggestion').slideUp('fast', function() {
                $('#cEmail').blur();
                $('#knkSuggestion').remove();
            })
            $('#cEmail').val(suggestEmailAddress);
        })
        $('#knkSuggestion').slideDown('fast', function() {
            $(this).blur();
        })
    }
}

export function getRTDomain(refd, trk){
    var finalDomain = getConfig().rtDomain;
    
    if(refd){
        if(refd.indexOf("cantsleephelp.com") != -1){ // ref is cantsleephelp
            finalDomain = "trk.ingscr1.com";    
            return finalDomain;
        }
        
        if(refd.indexOf("isleepbetter.co") != -1){ // ref is cantsleephelp
            finalDomain = "trk.bit-bytes.net";    
            return finalDomain;
        }
    }
    
    if(trk){
        if(trk == "ingscr1"){
            finalDomain = "trk.ingscr1.com";            
        }
        
        if(trk == "bitbytes"){
            finalDomain = "trk.bit-bytes.net";    
        }

        if(trk == "hexq2"){
            finalDomain = "trk.hexq2.com";    
        }
        
        if(trk == "simq3"){
            finalDomain = "trk.simq3.com";    
        }

        if(trk == "romq4"){
            finalDomain = "trk.romq4.com";    
        }
    }
    
    return finalDomain;
}

 export function isBase64(str) {
    if (str === '' || str.trim() === '') {
        return false;
    }
    try {
        return btoa(atob(str)) == str;
    } catch (err) {
        return false;
    }
}